import type { DashboardTenantSlug } from "./dashboard-tenants";

const EMBEDDED_OFFER_NAME_TO_SLUG: Record<string, DashboardTenantSlug> = {
  "urban unity": "urban-unity",
  "the artillery": "the-artillery",
  "the fitness ceo": "the-fitness-ceo",
  "scaling society": "scaling-society",
  ascend: "ascend",
  "ascend sales academy": "ascend",
  cr8her: "cr8her",
  "cr8 her": "cr8her",
};

export function getEmbeddedDashboardSlugByOfferName(
  offerName: string | null | undefined
): DashboardTenantSlug | null {
  if (!offerName) return null;
  return EMBEDDED_OFFER_NAME_TO_SLUG[offerName.trim().toLowerCase()] ?? null;
}

export function isEmbeddedOfferName(offerName: string | null | undefined): boolean {
  return getEmbeddedDashboardSlugByOfferName(offerName) !== null;
}
